import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner'
import './Buttons.scss'

export enum ButtonType {
  Negative = 'negative',
  Info = 'info',
  Warning = 'warning',
  Positive = 'positive',
}

interface IProps {
  /** Button name. */
  name: string
  /** Button icon. */
  icon?: string
  /** Called when button is clicked. */
  onClick?: () => void
  /** Button style. */
  type?: ButtonType
  /** Show loading spinner and disable button. */
  loading?: boolean
  /** Show loading spinner and disable button. */
  disabled?: boolean
}

export const TransparentButton = (props: IProps) => {
  const onClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    if (props.onClick && !props.loading) {
      props.onClick()
    }
  }

  const icon = props.icon && <i className={props.icon}></i>
  const classNames = ['transparent-button', props.type]

  if (props.disabled) {
    classNames.push('disabled')
  }

  return (
    <div className={classNames.join(' ')} onClick={onClick}>
      {props.loading ? (
        <LoadingSpinner size={14} />
      ) : (
        <>
          {icon} {props.name.toUpperCase()}
        </>
      )}
    </div>
  )
}
